<template>
  <v-container fluid class="pa-4">
    <!-- Header Section -->
    <div class="d-flex align-center mb-4">
      <v-icon color="primary" size="30" class="mr-3">mdi-warehouse</v-icon>
      <div>
        <h1 class="text-h5 font-weight-bold mb-0">Entrada a Inventario</h1>
        <div class="text-body-2 grey--text">
          Registrar nuevos productos al inventario
        </div>
      </div>
    </div>

    <!-- Store and Client Info Cards -->
    <v-row class="mb-4">
      <v-col cols="12" md="6">
        <v-card class="info-card elevation-0" outlined height="100%">
          <v-card-title class="pa-0">
            <v-toolbar flat class="minimal-toolbar">
              <div class="d-flex align-center">
                <div class="info-icon mr-3">
                  <v-icon color="primary" size="22">mdi-storefront-outline</v-icon>
                </div>
                <h3 class="section-title">Tienda</h3>
              </div>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="pa-4">
            <div class="info-content">
              <div class="info-item">
                <span class="info-label">Nombre:</span>
                <span class="info-value font-weight-medium">
                  {{ this.$store.state.seller.PartyName }}
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">
                  {{ get_name_typeId(this.$store.state.seller.typeid) }}:
                </span>
                <span class="info-value">
                  {{ this.$store.state.seller.PartyIdentification }}
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">Ciudad:</span>
                <span class="info-value">{{ this.$store.state.seller.CityName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Email:</span>
                <span class="info-value">{{ this.$store.state.seller.email }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="info-card elevation-0" outlined height="100%">
          <v-card-title class="pa-0">
            <v-toolbar flat class="minimal-toolbar">
              <div class="d-flex align-center">
                <div class="info-icon mr-3">
                  <v-icon color="success" size="22">mdi-account-check</v-icon>
                </div>
                <h3 class="section-title">Autorizado por</h3>
              </div>
              <v-spacer></v-spacer>
              <v-btn icon @click="openAuthorizerDialog" :loading="loading_users">
                <v-icon>mdi-account-switch</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="pa-4">
            <div class="info-content" v-if="selectedAuthorizer">
              <div class="info-item">
                <span class="info-label">Nombre:</span>
                <span class="info-value font-weight-medium">{{
                  selectedAuthorizer.user_name || selectedAuthorizer.user_email
                }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Email:</span>
                <span class="info-value">{{ selectedAuthorizer.user_email }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Rol:</span>
                <span class="info-value">
                  <v-chip
                    small
                    :color="
                      selectedAuthorizer.user_access === 'OWNER' ? 'primary' : 'success'
                    "
                  >
                    {{ selectedAuthorizer.user_access }}
                  </v-chip>
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">Verificado:</span>
                <span class="info-value">
                  <v-icon small color="success">mdi-check-decagram</v-icon>
                  Contraseña confirmada
                </span>
              </div>
            </div>
            <div v-else class="text-center py-5">
              <v-icon size="40" color="grey lighten-2">mdi-account-question</v-icon>
              <p class="grey--text mt-2 mb-0">No se ha seleccionado un autorizador</p>
              <v-btn
                text
                small
                color="primary"
                @click="openAuthorizerDialog"
                class="mt-2"
              >
                <v-icon left small>mdi-account-plus</v-icon>
                Seleccionar
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Products Table -->
    <v-card class="main-card elevation-0 mb-4" outlined>
      <v-card-title class="pa-0">
        <v-toolbar flat class="minimal-toolbar">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3">mdi-package-variant</v-icon>
            <h3 class="section-title">Productos</h3>
          </div>
          <v-spacer></v-spacer>
          <v-text-field
            ref="barcodeInput"
            v-model="barcode"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-barcode-scan"
            placeholder="Escanear código de barras"
            class="mr-3"
            style="max-width: 260px"
            @keyup.enter="onBarcodeScanned"
          ></v-text-field>
          <v-btn color="primary" @click="product_dialog = !product_dialog">
            <v-icon left>mdi-plus</v-icon>
            Agregar Producto
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <!-- Desktop Table -->
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-data-table
          :headers="headers_items"
          :items="items"
          :items-per-page="10"
          item-key="ean"
          class="minimal-table"
          :loading="loading_status"
          loading-text="Cargando productos..."
          loader-height="3"
          hide-default-footer
          v-show="items.length > 0"
        >
          <template v-slot:[`item.producto`]="{ item }">
            <div class="product-info">
              <div class="product-main font-weight-medium">
                {{ item.nombre }}
              </div>
              <div class="product-details text-caption grey--text">
                {{ item.brand }} Ref: {{ item.refe }} - {{ item.colorName }} -
                {{ item.talla }}
              </div>
            </div>
          </template>

          <template v-slot:[`item.categoria_grupo`]="{ item }">
            <div>
              <v-chip small label class="mr-1">{{ item.category }}</v-chip>
              <v-chip small label outlined>{{ item.grupoName }}</v-chip>
            </div>
          </template>

          <template v-slot:[`item.valores`]="{ item }">
            <div class="values-info text-right">
              <div class="value-price font-weight-medium">
                {{ formatCurrency(item.precio) }}
              </div>
              <div
                class="value-subtotal text-caption grey--text"
                v-if="item.descuento > 0"
              >
                Desc: {{ item.descuento }}%
              </div>
            </div>
          </template>

          <template v-slot:[`item.cantidad`]="{ item }">
            <div class="d-flex justify-center">
              <v-text-field
                :value="item.cantidad"
                type="number"
                min="0"
                dense
                hide-details
                outlined
                class="qty-input"
                @input="setItemQty(item, $event)"
              ></v-text-field>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small color="error" @click="delete_item(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>

          <!-- Footer with totals -->
          <template v-slot:body.append v-if="items.length > 0">
            <tr class="grey lighten-4">
              <td colspan="3" class="text-right font-weight-bold pa-4">TOTAL</td>
              <td class="text-center font-weight-bold">{{ totalQuantity }} und</td>
              <td class="text-right font-weight-bold">
                {{ formatCurrency(totalValue) }}
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </template>

      <!-- Mobile List -->
      <template v-else>
        <v-list v-if="items.length > 0" class="py-0">
          <template v-for="(item, index) in items">
            <v-list-item :key="item.ean" class="px-4 py-3">
              <v-list-item-content>
                <div class="d-flex justify-space-between align-start mb-2">
                  <div class="flex-grow-1">
                    <div class="font-weight-medium">{{ item.nombre }}</div>
                    <div class="text-caption grey--text">
                      {{ item.marca }} - {{ item.refe }}
                    </div>
                  </div>
                  <v-btn icon small color="error" @click="delete_item(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <div class="d-flex justify-space-between align-center">
                  <div>
                    <v-chip small label class="mr-1">{{ item.color }}</v-chip>
                    <v-chip small label>{{ item.talla }}</v-chip>
                  </div>
                  <div class="text-right d-flex align-center">
                    <div class="font-weight-medium mr-3">
                      {{ formatCurrency(item.precio) }}
                    </div>
                    <v-text-field
                      :value="item.cantidad"
                      type="number"
                      min="0"
                      dense
                      hide-details
                      outlined
                      label="Cant."
                      class="qty-input"
                      @input="setItemQty(item, $event)"
                    ></v-text-field>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < items.length - 1" :key="`div-${item.ean}`" />
          </template>

          <!-- Mobile Totals -->
          <v-list-item class="grey lighten-4 py-3">
            <v-list-item-content>
              <div class="d-flex justify-space-between align-center">
                <div class="font-weight-bold">TOTAL</div>
                <div class="text-right">
                  <div class="font-weight-bold">{{ formatCurrency(totalValue) }}</div>
                  <div class="text-caption">{{ totalQuantity }} unidades</div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <!-- Empty State -->
      <div v-if="items.length === 0 && !loading_status" class="text-center py-8">
        <v-icon size="48" color="grey lighten-2">mdi-package-variant-closed</v-icon>
        <h3 class="text-subtitle-1 mt-3 grey--text">No hay productos agregados</h3>
        <p class="text-caption grey--text mt-1 mb-0">
          Escanea un código o haz clic en "Agregar Producto" para comenzar
        </p>
      </div>
    </v-card>

    <!-- Motive Selection -->
    <v-card class="main-card elevation-0" outlined>
      <v-card-title class="pa-0">
        <v-toolbar flat class="minimal-toolbar">
          <div class="d-flex align-center">
            <v-icon color="warning" class="mr-3">mdi-text-box-outline</v-icon>
            <h3 class="section-title">Concepto de Entrada</h3>
          </div>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form v-model="validatemotive" ref="motiveform" @submit.prevent="save_receipt">
          <v-row align="center" dense>
            <v-col cols="12" md="8">
              <v-select
                v-model="motive"
                :items="FP"
                item-value="codigo"
                item-text="valor"
                return-object
                outlined
                dense
                hide-details="auto"
                :rules="f_required"
                label="Seleccionar concepto"
                prepend-inner-icon="mdi-format-list-bulleted"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                large
                color="success"
                type="submit"
                block
                :disabled="!canSubmit"
                :loading="loading_status"
              >
                <v-icon left>mdi-check</v-icon>
                Registrar Entrada
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Authorizer Selection Dialog -->
    <v-dialog v-model="authorizer_dialog" max-width="600px">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="primary">
            <v-icon class="mr-3">mdi-account-check</v-icon>
            <v-toolbar-title>Seleccionar Autorizador</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeAuthorizerDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-list v-if="authorizedUsers.length > 0">
            <template>
              <v-list-item
                v-for="user in authorizedUsers"
                :key="user.user_email"
                @click="selectAuthorizerForValidation(user)"
                :class="{
                  'blue lighten-5':
                    selectedAuthorizer &&
                    selectedAuthorizer.user_email === user.user_email,
                }"
              >
                <v-list-item-avatar>
                  <v-icon :color="user.user_access === 'OWNER' ? 'primary' : 'success'">
                    {{
                      user.user_access === "OWNER" ? "mdi-crown" : "mdi-shield-account"
                    }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    user.user_name || user.user_email
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ user.user_email }}
                    <v-chip
                      x-small
                      class="ml-2"
                      :color="user.user_access === 'OWNER' ? 'primary' : 'success'"
                    >
                      {{ user.user_access }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    v-if="
                      selectedAuthorizer &&
                      selectedAuthorizer.user_email === user.user_email
                    "
                    color="success"
                  >
                    mdi-check-circle
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="(authorizedUsers.length = 0)"
                :key="`divider-${user.user_email}`"
              ></v-divider>
            </template>
          </v-list>
          <div v-else class="text-center py-12">
            <v-progress-circular
              v-if="loading_users"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <template v-else>
              <v-icon size="64" color="grey lighten-2">mdi-account-off</v-icon>
              <h3 class="text-h6 mt-4 grey--text">
                No hay usuarios autorizados disponibles
              </h3>
              <p class="grey--text mt-2">
                No se encontraron usuarios con rol ADMIN o OWNER
              </p>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Password Confirmation Dialog -->
    <v-dialog v-model="password_dialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="secondary">
            <v-icon class="mr-3">mdi-lock-check</v-icon>
            <v-toolbar-title>Confirmar Autorización</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-6">
          <div class="text-center mb-4">
            <v-icon size="64" color="secondary">mdi-shield-lock</v-icon>
            <h3 class="text-h6 mt-3">Verificación de Seguridad</h3>
            <p class="text-body-2 grey--text mt-2">
              Por favor ingrese la contraseña de<br />
              <strong>{{
                tempAuthorizer
                  ? tempAuthorizer.user_name || tempAuthorizer.user_email
                  : ""
              }}</strong>
            </p>
          </div>
          <v-form
            ref="passwordForm"
            v-model="passwordValid"
            @submit.prevent="validatePassword"
          >
            <v-text-field
              v-model="authorizerPassword"
              label="Contraseña"
              type="password"
              outlined
              prepend-inner-icon="mdi-lock"
              :rules="[(v) => !!v || 'La contraseña es requerida']"
              :error-messages="passwordError"
              @input="passwordError = ''"
              autofocus
              @keyup.enter="validatePassword"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-6 pt-0">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelPasswordValidation">Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="validatePassword"
            :loading="validatingPassword"
            :disabled="!authorizerPassword"
          >
            <v-icon left>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Compact Product Search Dialog -->
    <v-dialog
      v-model="product_dialog"
      transition="dialog-top-transition"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card class="product-dialog-card">
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="primary" class="elevation-0">
            <v-icon class="mr-3">mdi-package-variant-plus</v-icon>
            <v-toolbar-title class="text-h6"
              >Agregar Productos al Inventario</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-chip
              v-if="items.length > 0"
              small
              color="white"
              text-color="primary"
              class="mr-3"
            >
              {{ items.length }} producto{{ items.length !== 1 ? "s" : "" }} agregado{{
                items.length !== 1 ? "s" : ""
              }}
            </v-chip>
            <v-btn icon dark @click="closeProductDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <!-- Compact Search Section -->
        <v-card class="search-section elevation-0 ma-0" outlined>
          <v-card-text class="pa-3">
            <v-form
              v-model="search_valid"
              ref="searchform"
              @submit.prevent="search_inventory"
            >
              <v-row align="center" no-gutters>
                <v-col cols="12" sm="2" md="2" class="pr-2">
                  <v-select
                    v-model="filters.field"
                    :items="[
                      { text: 'Nombre', value: 'NOMBRE' },
                      { text: 'Categoría', value: 'CATEGORIA' },
                      { text: 'Grupo', value: 'GRUPO' },
                      { text: 'Marca', value: 'MARCA' },
                      { text: 'Ref.', value: 'REFE' },
                      { text: 'Color', value: 'COLOR' },
                      { text: 'Talla', value: 'TALLA' },
                    ]"
                    item-text="text"
                    item-value="value"
                    label="Campo"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-filter-variant"
                  />
                </v-col>
                <v-col cols="12" sm="7" md="7" class="px-2">
                  <v-text-field
                    v-model="filters.value"
                    label="Buscar productos..."
                    placeholder="Ej: Camisa, Nike, Rojo, etc."
                    clearable
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    @keyup.enter="search_inventory"
                    @input="debouncedSearch"
                  />
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pl-2">
                  <v-btn
                    :disabled="!filters.value"
                    block
                    color="primary"
                    :loading="loading_status"
                    @click="search_inventory"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <!-- Compact Results Section -->
        <v-card-text class="pa-0 results-section">
          <!-- Compact Desktop Table -->
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-data-table
              :headers="headers_search"
              :items="inventory_lst"
              :items-per-page="10"
              class="compact-table"
              item-key="ean"
              :loading="loading_status"
              loader-height="3"
              loading-text="Buscando productos..."
              dense
            >
              <template v-slot:[`item.info`]="{ item }">
                <div class="compact-product-info py-1">
                  <div class="product-name font-weight-medium">{{ item.nombre }}</div>
                  <div class="product-details text-caption grey--text">
                    {{ item.marca }} • {{ item.refe }} • {{ item.color }} •
                    {{ item.talla }}
                  </div>
                </div>
              </template>

              <template v-slot:[`item.categoria`]="{ item }">
                <div class="text-center">
                  {{ get_categoria_name(item.categoria) }}
                </div>
              </template>

              <template v-slot:[`item.grupo`]="{ item }">
                <div class="text-center">
                  {{ get_grupo_name(item.grupo) }}
                </div>
              </template>

              <template v-slot:[`item.precio`]="{ item }">
                <div class="text-right price-info">
                  <div class="font-weight-bold primary--text">
                    {{ formatCurrency(item.precio) }}
                  </div>
                  <div class="text-caption error--text" v-if="item.descuento > 0">
                    -{{ item.descuento }}%
                  </div>
                </div>
              </template>

              <template v-slot:[`item.stock`]="{ item }">
                <div class="text-center">
                  <v-chip
                    x-small
                    :color="
                      item.stock > 10 ? 'success' : item.stock > 0 ? 'warning' : 'error'
                    "
                    dark
                  >
                    {{ item.stock || 0 }}
                  </v-chip>
                </div>
              </template>

              <template v-slot:[`item.cantidad`]="{ item }">
                <div class="text-center quantity-input">
                  <v-text-field
                    v-model.number="item.temp_quantity"
                    type="number"
                    min="1"
                    :max="item.stock || 999"
                    outlined
                    dense
                    hide-details
                    style="width: 80px"
                    @input="validateQuantity(item)"
                    @keyup.enter="addProductDirectly(item)"
                  />
                </div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="action-buttons text-center">
                  <v-btn
                    color="primary"
                    small
                    @click="addProductDirectly(item)"
                    :disabled="!item.temp_quantity || item.temp_quantity <= 0"
                  >
                    <v-icon left small>mdi-plus</v-icon>
                    Agregar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </template>

          <!-- Mobile List -->
          <template v-else>
            <v-list class="py-0" v-if="inventory_lst.length > 0">
              <div v-for="(item, index) in inventory_lst" :key="item.ean">
                <v-list-item class="mobile-product-item px-3 py-2">
                  <v-list-item-content>
                    <div class="d-flex justify-space-between align-start mb-2">
                      <div class="flex-grow-1">
                        <div class="font-weight-medium">{{ item.nombre }}</div>
                        <div class="text-caption grey--text">
                          {{ item.marca }} • {{ item.refe }} • {{ item.color }} •
                          {{ item.talla }}
                        </div>
                        <div class="mt-2 d-flex align-center">
                          <v-chip
                            x-small
                            label
                            color="primary"
                            class="mr-2"
                            :title="get_categoria_name(item.categoria)"
                          >
                            {{ get_categoria_name(item.categoria) }}
                          </v-chip>
                          <v-chip
                            x-small
                            label
                            outlined
                            color="secondary"
                            :title="get_grupo_name(item.grupo)"
                          >
                            {{ get_grupo_name(item.grupo) }}
                          </v-chip>
                        </div>
                      </div>
                      <div class="text-right ml-2">
                        <div class="font-weight-bold primary--text">
                          {{ formatCurrency(item.precio) }}
                        </div>
                        <v-chip
                          x-small
                          :color="item.stock > 0 ? 'success' : 'error'"
                          dark
                        >
                          Stock: {{ item.stock || 0 }}
                        </v-chip>
                      </div>
                    </div>

                    <div class="d-flex justify-space-between align-center mt-2">
                      <div class="d-flex align-center">
                        <v-text-field
                          v-model.number="item.temp_quantity"
                          type="number"
                          min="1"
                          :max="item.stock || 999"
                          outlined
                          dense
                          hide-details
                          style="width: 70px"
                          @input="validateQuantity(item)"
                        />
                      </div>
                      <v-btn
                        color="primary"
                        small
                        @click="addProductDirectly(item)"
                        :disabled="!item.temp_quantity || item.temp_quantity <= 0"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < inventory_lst.length - 1" />
              </div>
            </v-list>
          </template>

          <!-- Empty State -->
          <div
            v-if="inventory_lst.length === 0 && !loading_status"
            class="empty-state text-center py-8"
          >
            <v-icon size="48" color="grey lighten-2">mdi-package-variant-closed</v-icon>
            <h4 class="mt-3 grey--text">
              {{
                filters.value
                  ? "No se encontraron productos"
                  : "Busque productos para agregar"
              }}
            </h4>
            <p class="grey--text">
              {{
                filters.value
                  ? "Intente con otros términos de búsqueda"
                  : "Use el campo de búsqueda para encontrar productos"
              }}
            </p>
          </div>

          <!-- Loading State -->
          <div v-if="loading_status" class="text-center py-8">
            <v-progress-circular
              indeterminate
              color="primary"
              size="40"
            ></v-progress-circular>
            <p class="mt-3 grey--text">Buscando productos...</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Print Drawer -->
    <noteViewer :item="docInfo" :dialog="showPrint" @close="showPrint = false" />
    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver } from "@/services/webserver.js";
import createClient from "@/utils/createClient.js";
import noteViewer from "@/components/doc_viewer_report.vue";
import settings from "@/utils/settings.js";

export default {
  name: "IAIn",
  components: { noteViewer },
  data() {
    const settingsData = settings();
    return {
      setting: settingsData,
      productAdded: false,
      timeout: 3000,
      search_valid: false,
      loading_status: false,
      loading_users: false,
      validatemotive: false,
      authorizer_dialog: false,
      password_dialog: false,
      product_dialog: false,
      showPrint: false,
      validatingPassword: false,
      passwordValid: false,
      docInfo: { doc: null, items: [], payments: [] },
      id_lst: settingsData["type_document_identifications"] || [],
      // Snackbar
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },

      // Data
      inventory_lst: [],
      filters: { field: "NOMBRE", value: "" },
      barcode: "",
      items: [],
      motive: { codigo: null, valor: null },
      dataURL: "",

      // Product selection
      currentPage: 1,

      // Users and Authorization
      users: [],
      selectedAuthorizer: null,
      tempAuthorizer: null,
      authorizerPassword: "",
      passwordError: "",

      // Store
      store: createClient(),

      // Totals
      totals: { qty: 0, total: 0 },

      // Lists
      FP: [],

      // Headers
      headers_items: [
        {
          text: "Producto",
          value: "producto",
          sortable: false,
          width: "40%",
        },
        {
          text: "Categoría / Grupo",
          value: "categoria_grupo",
          sortable: false,
          width: "25%",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          align: "center",
          width: "15%",
        },
        {
          text: "Valor",
          value: "valores",
          align: "right",
          width: "15%",
        },
        {
          text: "",
          value: "actions",
          align: "center",
          sortable: false,
          width: "5%",
        },
      ],

      headers_search: [
        {
          text: "Producto",
          value: "info",
          sortable: false,
          width: "30%",
        },
        {
          text: "Categoría",
          value: "categoria",
          align: "center",
          width: "10%",
        },
        {
          text: "Grupo",
          value: "grupo",
          align: "center",
          width: "10%",
        },
        {
          text: "Precio",
          value: "precio",
          align: "right",
          width: "12%",
        },
        {
          text: "Stock",
          value: "stock",
          align: "center",
          width: "8%",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          align: "center",
          width: "15%",
        },
        {
          text: "Agregar",
          value: "actions",
          align: "center",
          sortable: false,
          width: "15%",
        },
      ],

      // Validation
      f_required: [(v) => !!v || "Campo requerido"],
    };
  },

  computed: {
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.cantidad || 0), 0);
    },

    totalValue() {
      return this.items.reduce((sum, item) => {
        const precio = parseFloat(item.precio) || 0;
        const cantidad = parseFloat(item.cantidad) || 0;
        const descuento = parseFloat(item.descuento) || 0;
        const subtotal = precio * cantidad;
        const descuentoValor = subtotal * (descuento / 100);
        return sum + (subtotal - descuentoValor);
      }, 0);
    },

    canSubmit() {
      return this.motive.codigo && this.items.length > 0 && this.selectedAuthorizer;
    },

    authorizedUsers() {
      return this.users.filter((user) => ["ADMIN", "OWNER"].includes(user.user_access));
    },
  },

  mounted() {
    console.log(window.settings);
    this.store = window.store;
    this.FP = window.settings["AJ-ENTRADA"];
    //this.get_users();
    this.focusBarcode();
  },

  methods: {
    get_name_typeId(e) {
      var doc = this.id_lst.find((itm) => itm.code === e);
      return doc ? doc.name : "";
    },

    get_categoria_name(codigo) {
      if (!codigo) return "";
      // Buscar en window.settings["CATEGORIA"] que es un array
      var categorias =
        window.settings && window.settings["CATEGORIA"]
          ? window.settings["CATEGORIA"].find((item) => item.codigo === codigo)
          : null;
      // Devolver el valor si existe y es diferente del código
      return categorias && categorias.valor && categorias.valor !== codigo
        ? categorias.valor
        : codigo;
    },

    get_grupo_name(codigo) {
      if (!codigo) return "";
      // Buscar en window.settings["GRUPO"] que es un array
      var grupos =
        window.settings && window.settings["GRUPO"]
          ? window.settings["GRUPO"].find((item) => item.codigo === codigo)
          : null;
      // Devolver el valor si existe y es diferente del código
      return grupos && grupos.valor && grupos.valor !== codigo ? grupos.valor : codigo;
    },
    // Get users list
    async get_users() {
      const qry = {
        store: window.profile.store_id,
        table: "users",
        filters: [
          {
            field: "store_id",
            operator: "=",
            value: window.profile.store_id,
          },
          {
            field: "user_access",
            operator: " IN ",
            value: "'ADMIN','OWNER'",
          },
        ],
      };

      this.loading_users = true;

      try {
        const result = await new Promise((resolve, reject) => {
          webserver(
            "get_table",
            qry,
            (data) => resolve(data),
            () => reject([])
          );
        });

        this.users = result || [];

        if (this.users.length === 0) {
          this.showMessage("No se encontraron usuarios autorizados", "warning");
        }
      } catch (error) {
        this.users = [];
        this.showMessage("Error al cargar usuarios", "error");
      } finally {
        this.loading_users = false;
      }
    },

    // Authorization methods
    openAuthorizerDialog() {
      this.authorizer_dialog = true;
      if (this.users.length === 0) {
        this.get_users();
      }
    },

    selectAuthorizerForValidation(user) {
      this.tempAuthorizer = user;
      this.authorizerPassword = "";
      this.passwordError = "";
      this.password_dialog = true;
    },

    closeAuthorizerDialog() {
      this.authorizer_dialog = false;
      this.tempAuthorizer = null;
    },

    cancelPasswordValidation() {
      this.password_dialog = false;
      this.authorizerPassword = "";
      this.passwordError = "";
      this.tempAuthorizer = null;
    },

    async validatePassword() {
      if (!this.authorizerPassword) {
        this.passwordError = "La contraseña es requerida";
        return;
      }

      this.validatingPassword = true;

      // Generate MD5 hash of the password
      const md5Password = this.md5(this.authorizerPassword);

      // Check if password matches
      if (this.tempAuthorizer.user_password === md5Password) {
        this.selectedAuthorizer = this.tempAuthorizer;
        this.password_dialog = false;
        this.authorizer_dialog = false;
        this.authorizerPassword = "";
        this.passwordError = "";
        this.tempAuthorizer = null;
        this.showMessage(
          `Autorizado por ${
            this.selectedAuthorizer.user_name || this.selectedAuthorizer.user_email
          }`,
          "success"
        );
      } else {
        this.passwordError = "Contraseña incorrecta";
        this.authorizerPassword = "";
      }

      this.validatingPassword = false;
    },

    // MD5 Hash function
    md5(string) {
      function md5cycle(x, k) {
        var a = x[0],
          b = x[1],
          c = x[2],
          d = x[3];
        a = ff(a, b, c, d, k[0], 7, -680876936);
        d = ff(d, a, b, c, k[1], 12, -389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, -1044525330);
        a = ff(a, b, c, d, k[4], 7, -176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, -1473231341);
        b = ff(b, c, d, a, k[7], 22, -45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, -1958414417);
        c = ff(c, d, a, b, k[10], 17, -42063);
        b = ff(b, c, d, a, k[11], 22, -1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, -40341101);
        c = ff(c, d, a, b, k[14], 17, -1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);
        a = gg(a, b, c, d, k[1], 5, -165796510);
        d = gg(d, a, b, c, k[6], 9, -1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, -373897302);
        a = gg(a, b, c, d, k[5], 5, -701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, -660478335);
        b = gg(b, c, d, a, k[4], 20, -405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, -1019803690);
        c = gg(c, d, a, b, k[3], 14, -187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, -1444681467);
        d = gg(d, a, b, c, k[2], 9, -51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, -1926607734);
        a = hh(a, b, c, d, k[5], 4, -378558);
        d = hh(d, a, b, c, k[8], 11, -2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, -35309556);
        a = hh(a, b, c, d, k[1], 4, -1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, -155497632);
        b = hh(b, c, d, a, k[10], 23, -1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, -358537222);
        c = hh(c, d, a, b, k[3], 16, -722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, -640364487);
        d = hh(d, a, b, c, k[12], 11, -421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, -995338651);
        a = ii(a, b, c, d, k[0], 6, -198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, -1416354905);
        b = ii(b, c, d, a, k[5], 21, -57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, -1894986606);
        c = ii(c, d, a, b, k[10], 15, -1051523);
        b = ii(b, c, d, a, k[1], 21, -2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, -30611744);
        c = ii(c, d, a, b, k[6], 15, -1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, -145523070);
        d = ii(d, a, b, c, k[11], 10, -1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
      }
      function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
      }
      function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | (~b & d), a, b, x, s, t);
      }
      function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & ~d), a, b, x, s, t);
      }
      function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
      }
      function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | ~d), a, b, x, s, t);
      }
      function md51(s) {
        var n = s.length,
          state = [1732584193, -271733879, -1732584194, 271733878],
          i;
        for (i = 64; i <= s.length; i += 64) {
          md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < s.length; i++) tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
          md5cycle(state, tail);
          for (i = 0; i < 16; i++) tail[i] = 0;
        }
        tail[14] = n * 8;
        md5cycle(state, tail);
        return state;
      }
      function md5blk(s) {
        var md5blks = [],
          i;
        for (i = 0; i < 64; i += 4) {
          md5blks[i >> 2] =
            s.charCodeAt(i) +
            (s.charCodeAt(i + 1) << 8) +
            (s.charCodeAt(i + 2) << 16) +
            (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
      }
      var hex_chr = "0123456789abcdef".split("");
      function rhex(n) {
        var s = "",
          j = 0;
        for (; j < 4; j++)
          s += hex_chr[(n >> (j * 8 + 4)) & 0x0f] + hex_chr[(n >> (j * 8)) & 0x0f];
        return s;
      }
      function hex(x) {
        for (var i = 0; i < x.length; i++) x[i] = rhex(x[i]);
        return x.join("");
      }
      function add32(a, b) {
        return (a + b) & 0xffffffff;
      }
      return hex(md51(string));
    },

    // Utilities
    formatCurrency(value) {
      if (!value && value !== 0) return "$0";
      return (
        "$" +
        parseFloat(value).toLocaleString("es", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      );
    },

    showMessage(text, color = "info") {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout: 3000,
      };
    },

    // Editar la cantidad directamente en la tabla de ítems.
    setItemQty(item, value) {
      const n = Math.max(0, Math.floor(parseFloat(value) || 0));
      this.$set(item, "cantidad", n);
    },

    // Product Management
    delete_item(item) {
      const index = this.items.indexOf(item);
      if (index !== -1) {
        this.items.splice(index, 1);
        this.showMessage("Producto eliminado", "info");
      }
    },

    // Product Dialog Methods
    closeProductDialog() {
      this.product_dialog = false;
      this.filters.value = "";
      this.inventory_lst = [];
      this.currentPage = 1;
    },

    // Initialize temp_quantity for all items
    initializeQuantities() {
      this.inventory_lst.forEach((item) => {
        if (!item.temp_quantity) {
          this.$set(item, "temp_quantity", 1);
        }
      });
    },

    validateQuantity(item) {
      if (!item.temp_quantity || item.temp_quantity < 1) {
        this.$set(item, "temp_quantity", 1);
      } else if (item.temp_quantity > (item.stock || 999)) {
        this.$set(item, "temp_quantity", item.stock || 999);
      }
    },

    onBarcodeScanned() {
      const code = (this.barcode || "").trim();
      this.barcode = "";
      if (code) this.get_barcode(code);
    },

    // Busca en el MAESTRO (id_pos de 6 dígitos) por un campo exacto.
    queryMaster(field, value, cb) {
      const qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id.substring(0, 6),
          },
          { field, operator: "=", value },
        ],
      };
      webserver("get_catalog", qry, (data) => {
        cb(Array.isArray(data) && data[0] ? data[0] : null);
      });
    },

    get_barcode(code) {
      this.loading_status = true;
      // En el maestro el código puede estar en 'ean' o en 'refe' (mismo criterio
      // que el escáner de auditoría). Se intenta ean y, si no, refe.
      this.queryMaster("ean", code, (byEan) => {
        if (byEan) {
          this.loading_status = false;
          this.addScanned(byEan);
          this.focusBarcode();
          return;
        }
        this.queryMaster("refe", code, (byRefe) => {
          this.loading_status = false;
          if (byRefe) {
            this.addScanned(byRefe);
          } else {
            this.showMessage(`Producto con código ${code} no encontrado`, "error");
          }
          this.focusBarcode();
        });
      });
    },

    addScanned(item) {
      this.$set(item, "temp_quantity", 1);
      this.addProductDirectly(item); // dedup/incremento ya implementado
    },

    focusBarcode() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus();
        }, 50);
      });
    },

    addProductDirectly(item) {
      const quantity = item.temp_quantity || 1;

      if (quantity <= 0) {
        this.showMessage("Cantidad inválida", "error");
        return;
      }

      if (quantity > (item.stock || 999)) {
        this.showMessage(
          `La cantidad no puede exceder el stock disponible (${item.stock})`,
          "error"
        );
        return;
      }

      const newItem = { ...item, cantidad: quantity };
      delete newItem.order_date;
      delete newItem.temp_quantity;

      const index = this.items.findIndex((itm) => itm.ean === newItem.ean);
      if (index === -1) {
        this.items.push(newItem);
        this.showMessage(
          `${quantity} ${quantity === 1 ? "unidad" : "unidades"} de ${
            newItem.nombre
          } agregado${quantity === 1 ? "" : "s"}`,
          "success"
        );
      } else {
        this.items[index].cantidad += quantity;
        this.showMessage(
          `${quantity} ${quantity === 1 ? "unidad" : "unidades"} adicional${
            quantity === 1 ? "" : "es"
          } agregada${quantity === 1 ? "" : "s"}`,
          "success"
        );
      }

      // Reset quantity to 1 for next addition
      this.$set(item, "temp_quantity", 1);
    },

    // Debounced search for better performance
    debouncedSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.filters.value && this.filters.value.length >= 2) {
          this.search_inventory();
        }
      }, 500);
    },

    add2concepts(item) {
      const newItem = { ...item, cantidad: 1 };
      delete newItem.order_date;

      const index = this.items.findIndex((itm) => itm.ean === newItem.ean);
      if (index === -1) {
        this.items.push(newItem);
      } else {
        this.items[index].cantidad += 1;
      }

      this.productAdded = true;
      this.showMessage("Producto agregado correctamente", "success");
    },

    // Search
    search_inventory(e) {
      if (e) e.preventDefault();

      if (!this.filters.value) {
        this.showMessage("Ingrese un término de búsqueda", "warning");
        return;
      }

      this.loading_status = true;

      const qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id.substring(0, 6),
          },
          {
            field: this.filters.field,
            operator: " LIKE ",
            value: this.filters.value,
          },
        ],
      };

      webserver("get_catalog", qry, (data) => {
        //console.log(data);
        this.loading_status = false;
        this.inventory_lst = data;

        // Initialize temp_quantity for all items
        this.initializeQuantities();

        if (data.length === 0) {
          this.showMessage("No se encontraron productos", "info");
        } else {
          this.showMessage(`${data.length} productos encontrados`, "success");
        }
      });
    },

    // Save Receipt
    save_receipt(e) {
      if (e) e.preventDefault();

      this.$refs.motiveform.validate();

      if (!this.canSubmit) {
        let missingField = "";
        if (!this.motive.codigo) missingField = "el concepto";
        else if (this.items.length === 0) missingField = "productos";
        else if (!this.selectedAuthorizer) missingField = "el autorizador";

        this.showMessage(`Debe seleccionar ${missingField}`, "warning");
        return;
      }

      this.loading_status = true;

      // Create client object from authorizer
      const authorizerClient = {
        PartyIdentification: this.store.store_business_id,
        PartyName:
          this.selectedAuthorizer.user_name || this.selectedAuthorizer.user_email,
        PartyEmail: this.selectedAuthorizer.user_email,
        PartyPhone: this.store.store_phone,
        AddressLine: this.store.store_address,
        typeid: "13", // Default to CC
      };

      const qry = {
        doc: {
          doc_type: "stockIn",
          doc_value: this.totalValue,
          store: window.store.store_id,
          userId: window.profile.user_email,
        },
        items: this.items,
        paidTo: authorizerClient,
        seller: window.seller,
        store: window.store.store_id,
        payments: [
          {
            payment_code: this.motive.codigo,
            payment_concept: this.motive.valor,
            payment_reference: "",
            payment_value: this.totalValue,
          },
        ],
      };

      webserver("put_stock", qry, (data) => {
        //console.log(data);
        this.loading_status = false;
        this.resetDoc();
        this.docInfo = data;
        this.showPrint = true;
        this.showMessage("Entrada registrada exitosamente", "success");
      });
    },

    resetDoc() {
      this.motive = { codigo: null, valor: null };
      this.items = [];
      // Don't reset selectedAuthorizer - keep it for next transaction
    },

    // Printing
    print_doc() {
      const printWindow = window.open("", "", "height=600, width=400");
      printWindow.document.write('<img src="' + this.dataURL + '" width="100%">');
      printWindow.print();
      printWindow.document.close();
      setTimeout(() => {
        printWindow.close();
      }, 500);
    },

    print_receipt(data) {
      const LS = 50;
      const itemsQty = data.items.length * LS * 3;
      const elem = document.createElement("canvas");
      elem.width = 945;
      elem.height = 1800 + itemsQty;

      const center = elem.width / 2;
      const left = 10;
      let line = 150;
      const right = elem.width - left;
      const ctx = elem.getContext("2d");

      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";

      ctx.font = "bold 60px Arial";
      ctx.fillText(window.seller.PartyIdentification_Id, center, line);
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.fillText(window.seller.PartyName, center, line);
      line += LS;
      ctx.fillText("Nit : " + window.seller.PartyIdentification, center, line);

      line += LS;
      ctx.fillText(
        window.seller.AddressLine + ", " + window.seller.CityName,
        center,
        line
      );
      line += LS;
      ctx.font = "bold 35px Arial";
      ctx.fillText("ENTRADA DE INVENTARIO", center, line);
      ctx.font = "bold 40px Arial";
      line += LS;
      ctx.fillText("No. " + data.document.doc_number, center, line);
      line += LS;
      ctx.fillText(data.document.issueDate, center, line);
      line += LS;
      ctx.textAlign = "start";
      ctx.fillText("Autorizado por: " + data.buyer.PartyName, left, line);
      line += LS;
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";
      ctx.fillText("Productos", center, line);
      line += LS;
      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;

      data.items.forEach((row) => {
        const price = parseFloat(row.precio) * parseFloat(row.cantidad);
        const description =
          row.marca + "-" + row.refe + "-" + row.color + "-" + row.talla;
        ctx.textAlign = "start";
        ctx.fillText(row.cantidad, left, line);
        ctx.textAlign = "start";
        ctx.fillText(description, left + 50, line);
        ctx.textAlign = "end";
        ctx.fillText(price.toLocaleString(), right, line);
        line += LS;
      });

      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;

      line += LS;

      ctx.textAlign = "center";
      ctx.fillText("Concepto", center, line);
      line += LS;

      data.payments.forEach((row) => {
        ctx.textAlign = "start";
        ctx.fillText(row.payment_concept, left, line);
        ctx.textAlign = "end";
        ctx.fillText(parseInt(row.payment_value).toLocaleString(), right, line);
        line += LS;
      });

      line += LS;
      line += LS;

      this.dataURL = elem.toDataURL();
      this.showPrint = true;
    },
  },
};
</script>

<style scoped>
/* Info Cards */
.info-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.info-icon {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-size: 0.875rem;
  color: #666;
  min-width: 80px;
}

.info-value {
  font-size: 0.875rem;
  color: #333;
}

/* Main Card */
.main-card {
  border: 1px solid #e0e0e0;
}

/* Editable quantity input in items table */
.qty-input {
  max-width: 96px;
}

.qty-input >>> input {
  text-align: center;
  font-weight: 700;
  padding: 4px 0;
}

.minimal-toolbar {
  border-bottom: 1px solid #e0e0e0;
  padding: 8px 16px;
  min-height: 52px;
}

.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
}

/* Data Table */
.minimal-table {
  border: none !important;
}

.minimal-table >>> .v-data-table__wrapper {
  border: none;
}

.minimal-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #666 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 0.8125rem !important;
  padding: 8px 12px !important;
}

.minimal-table >>> tbody tr {
  border-bottom: 1px solid #f0f0f0 !important;
  transition: background-color 0.2s;
}

.minimal-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.minimal-table >>> tbody tr td {
  padding: 8px 12px !important;
  font-size: 0.875rem !important;
}

/* Product Info */
.product-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product-main {
  color: #333;
}

.product-details {
  color: #666;
}

.product-search-info {
  padding: 8px 0;
}

/* Values */
.values-info {
  min-width: 120px;
}

.value-price {
  color: #333;
}

.value-subtotal {
  color: #666;
}

/* Print Drawer */
.print-drawer .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}

/* Loading */
.minimal-table >>> .v-data-table__progress {
  height: 3px !important;
}

/* Enhanced Product Dialog Styles */
.product-dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.search-section {
  background-color: #f8f9fa;
  border-radius: 0;
  border-bottom: 1px solid #e0e0e0;
}

.results-section {
  max-height: 600px;
  overflow-y: auto;
}

/* Compact Table Styles */
.compact-table {
  border: none !important;
}

.compact-table >>> .v-data-table__wrapper {
  border: none;
  box-shadow: none;
}

.compact-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #333 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 0.75rem !important;
  padding: 8px 12px !important;
  height: 40px !important;
  white-space: nowrap;
}

.compact-table >>> tbody tr {
  border-bottom: 1px solid #f0f0f0 !important;
  transition: all 0.2s ease;
  height: 60px !important;
}

.compact-table >>> tbody tr:hover {
  background-color: #f5f7fa !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.compact-table >>> tbody tr td {
  padding: 6px 8px !important;
  font-size: 0.75rem !important;
  vertical-align: middle;
}

/* Category and Group chip styling */
.compact-table .v-chip.v-size--x-small {
  height: 20px !important;
  font-size: 0.6875rem !important;
  padding: 0 6px !important;
}

.compact-table .v-chip .v-chip__content {
  padding: 0 !important;
  line-height: 20px !important;
}

.compact-product-info {
  min-height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-name {
  line-height: 1.2;
  margin-bottom: 2px;
  color: #1a1a1a;
  font-size: 0.875rem;
}

.product-details {
  line-height: 1.1;
  font-size: 0.7rem;
}

.product-categories {
  margin-top: 4px;
}

.price-info {
  min-width: 80px;
}

.quantity-input {
  width: 100px;
}

.quantity-input .v-text-field {
  margin: 0;
}

.quantity-input .v-text-field >>> .v-input__control {
  min-height: 36px !important;
}

.quantity-input .v-text-field >>> .v-input__slot {
  min-height: 36px !important;
  padding: 0 8px !important;
}

.quantity-input .v-text-field >>> input {
  text-align: center !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  color: #333 !important;
  padding: 8px 4px !important;
  line-height: 1.2 !important;
}

.action-buttons {
  white-space: nowrap;
}

.mobile-product-item {
  border-radius: 6px;
  margin: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
}

.mobile-product-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.empty-state {
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  margin: 16px;
}

/* Animations */
.product-dialog-card .v-card__title {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

/* Search Enhancement */
.search-section .v-text-field__details,
.search-section .v-select__details {
  display: none !important;
}

/* Compact responsive adjustments */

/* Responsive */
@media (max-width: 960px) {
  .section-title {
    font-size: 1.125rem;
  }

  .minimal-toolbar {
    padding: 12px 16px;
  }

  .info-card .v-card__text {
    padding: 16px !important;
  }

  .results-section {
    max-height: 400px;
  }

  .product-card-info {
    min-height: 60px;
  }
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1rem;
  }

  .minimal-toolbar {
    padding: 12px;
  }

  .info-item {
    flex-wrap: wrap;
  }

  .info-label {
    min-width: 100%;
    margin-bottom: 4px;
  }

  .results-section {
    max-height: 350px;
  }

  .mobile-product-item {
    margin: 4px;
  }

  .quantity-controls {
    flex-direction: row;
    gap: 8px;
  }

  /* Mobile quantity input fixes */
  .mobile-product-item .v-text-field >>> input {
    text-align: center !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    color: #333 !important;
    padding: 8px 4px !important;
  }
}
</style>
